import script from "./OutreachDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OutreachDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OutreachDashboard.vue?vue&type=style&index=0&id=4c293dd8&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c293dd8"]])

export default __exports__